import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { OpsSubscriptionMessageModal } from './ops-subscription-message-modal.component';
import { OpsSubscriptionModalService } from '@ops/shared-types';
@Component({
  selector: 'ops-subscription-modal-wrapper',
  standalone: true,
  imports: [CommonModule, OpsSubscriptionMessageModal, TranslateModule],
  template: `
    <ops-subscription-message-modal
      *ngIf="modalState.isOpen"
      [statusType]="modalState.config?.statusType || 'success'"
      [modalTitle]="modalState.config?.modalTitle || (translateService.instant('OPS_SUBSCRIPTION_SETTINGS.SUBSCRIPTION_STATUS'))"
      [modalText]="modalState.config?.modalText || ''"
      (confirmed)="handleConfirmation($event)"
      (closeModal)="modalService.closeModal()"
    ></ops-subscription-message-modal>
  `,
})
export class OpsSubscriptionModalWrapper {
  modalState = { isOpen: false, config: null };

  constructor(
    public modalService: OpsSubscriptionModalService,
    public translateService: TranslateService
  ) {
    this.modalService.getModalState().subscribe((state) => {
      this.modalState = state;
    });
  }

  handleConfirmation(confirmed: boolean): void {
    // console.log('HERE');
    // this.modalService.confirm(confirmed);
  }
}
